import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import Sentence from './invitation/componetns/Sentence';

import Grid from '@mui/material/Grid2';

const API_URL = process.env.REACT_APP_API_URL;

const InvalidInvitation = () => {

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
            <Grid item xs={12} sm={12} md={6}>
                <Box sx={{p:4}} alignItems="center">
                    <Sentence size='1.0rem'>エラーが発生しました。主催者にお知らせください。</Sentence>

                </Box>
                        {/* <Typography variant="h5" gutterBottom>エラーが発生しました。主催者にお知らせください。</Typography> */}
            </Grid>                   
        </Grid>
    );
};

export default InvalidInvitation;
